import { ButtonProps } from '@mui/material'
import ResultCardCtaSingle from './result-card/result-card-cta-single'
import { getActionCtaIconByString } from '../constants/actions'
import { democracyEngineState } from '../context/democracy-engine-context'
import React from 'react'

export const DemocracyEngineDonateButton = ({
  organization,
  recipientId,
  action_id,
  label = 'Donate',
  disabled,
  ...buttonProps
}: {
  organization?: Queries.SanityOrganization | null
  recipientId?: string
  action_id: string
  label?: string
} & ButtonProps) => {
  const { donateTo } = democracyEngineState()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    if (organization && recipientId) {
      donateTo(organization, recipientId, action_id)
    }
    buttonProps.onClick?.(event)
  }

  return (
    <ResultCardCtaSingle
      {...buttonProps}
      disabled={disabled || !recipientId}
      label={label}
      icon={getActionCtaIconByString('donate')}
      onClick={handleClick}
    />
  )
}
